<template>
    <div class="acountStatus"> 
        <div class="mainTitle text-center my-3">
            <h3 class="mb-4">{{$t('depositList')}}</h3>
            <message-component :message="response_msg" :messageType="msg_type"></message-component>
        </div>
        <div class="whiteBG radius pt-3"> 
            <div class="d-flex flex-wrap tabcenter justify-content-between border-bottom pb-3 px-3 mb-2"> 
                <div></div>
                <div class="requestbtn commanfilter d-flex align-items-center">
                   <filter-component></filter-component>  
                </div>   
            </div>
            <div class="inMiddle-area table-responsive">
                <table class="table pmmTable">
                    <thead>
                        <tr>
							<th>{{$t('transId')}}</th>
							<th>{{$t('accountId')}}</th>
                            <th>{{$t('amount')}}</th>
							<th>{{$t('currency')}}</th>
                            <th>{{$t('Status')}}</th>
							<th>{{$t('Method')}}</th>
							<th>{{$t('type')}}</th>
							<th>{{$t('created')}}</th>
							<th>{{$t('action')}}</th>
                        </tr>
                    </thead>
                    <tbody v-if="(!pageLoader && depositList != '' && depositList.totalRecords > 0)">
                        <tr v-for="list in depositList.records" >
							<td>{{list.transaction_id}} </td>
							
                            <td>{{list.account_id}} </td>
                            <td>{{list.amount}}</td>
                            <td><img :src="'../../../../static/fxView/images/'+currency[list.currency.toUpperCase()]" class="data_currency"></td>
                            <td>
								<span v-if="list.payment_status == '' || list.payment_status == null">-</span>
								<span class="badge badge-pill badge-warning" v-if="parseInt(list.payment_status) == -1 || parseInt(list.payment_status) == 0">{{paymentStatus[list.payment_status]}}</span>
								<span class="badge badge-pill badge-danger" v-if="parseInt(list.payment_status) == 2 || parseInt(list.payment_status) == 3 || parseInt(list.payment_status) == 4">{{paymentStatus[list.payment_status]}}</span>
								<span class="badge badge-pill badge-success" v-if="parseInt(list.payment_status) == 1">{{paymentStatus[list.payment_status]}}</span>
                            </td>
							<td v-html="(list.deposit_method != '' && list.deposit_method != null)?depositMethod[list.deposit_method] : '-'"></td>
							<td v-html="(list.deposit_type != '' && list.deposit_type != null)?depositType[list.deposit_type] : '-'"></td>
							<td>{{list.created | moment("DD MMMM YYYY")}}</td>
							<td>
								<router-link :to="{name: 'fxView.depositTransaction' , query: { 'id': list.transaction_id}}"  title="View" data-placement="top"  data-toggle="tooltip">
                                    <feather type="eye"></feather>
                                </router-link>
							</td>
                        </tr>
                    </tbody>
                    
                    <loader-component :pageloader_value="pageLoader" :type="'table'" :colspan="col_span" :list="depositList" v-else></loader-component>
                </table>
            </div>
        </div>
        <pagination :getList="depositList" :limit="pageLimit" v-if="depositList.totalRecords > 0"></pagination>
    </div> 
</template>
<script>
    import { fxViewMixins } from '@/plugins/fxView'
    import { Const } from '@/plugins/fxView/provider/candle-history/lib/const.cls'
    export default {
        name: 'Dashboard',
        mixins: [fxViewMixins],
        data() {
            return {
                //===========prop in loader component=======
                col_span : 9,
                //============message and loader ===========
                response_msg : '',
                msg_type : '',
                pageLoader : false,
                loaderFuncRun : '1',
                //==========================================
                pageLimit : '15',
                search : '',
                page : '1', 
            }
        },
        methods:{
            listing(){
                let inputJson = {
                    'globalParams' : {
                        filter: {},
                        sort: [],
                        search: this.search,
                        page: this.page,
                        perPage: parseInt(this.pageLimit),
                    } ,'localParams' : {'parameter' : this , 'loaderFuncRun' : this.loaderFuncRun}
                }
                this._runGetDepositList(inputJson)
            }
        },
        created(){
            if(this.$store.getters[Const.GET_DEPOSIT_LIST] != ''){
                this.loaderFuncRun = '0'
            }
            this.listing()
        }
    }
</script>


// WEBPACK FOOTER //
// src/components/fxView/deposit/deposit_listing.vue